import ConfirmDialog from "./ConfirmDialog";
import {useNews} from "../../context/NewsContext";
import {deleteNews} from "../../clients/NewsApiClient";
import {useEffect} from "react";
import sendSuccessAlert from "../../services/alertService";


const DeleteNewsForm = ({onDelete}) => {

    const {
        deleteIsOpen,
        setDeleteIsOpen,
        selectedNews
    } = useNews();

    useEffect(() => {
        if (!deleteIsOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                setDeleteIsOpen(false)
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [deleteIsOpen, setDeleteIsOpen]);

    async function handleSubmit() {
        await deleteNews(selectedNews?.id)
        onDelete()
        setDeleteIsOpen(false);
        sendSuccessAlert('Новость успешно удалена')
    }

    return (
        <div>
            <ConfirmDialog
                isOpen={deleteIsOpen}
                onClose={() => setDeleteIsOpen(false)}
                text={
                    <>
                        Вы действительно хотите удалить новость <b>"{selectedNews?.title || ""}"</b>?
                    </>
                }
                onSubmit={handleSubmit}
            />
        </div>
    );
}

export default DeleteNewsForm;